import React, { useEffect, useState } from 'react'
import { Table, Col, Row, Card, message, Popover, Button } from 'antd'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import inventorySrc from '../../inventorySrc'
import Utils from '../../../../utils/Utils'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'

function OrdersTable(props) {

    const [dataSource, setDataSource] = useState([])
    const [dataTable, setDataTable] = useState([])
    const [existMoreInfo, setExistMoreInfo] = useState(false)
    const [nextPage, setNextPage] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (props.keyTab === '7' || props.fetchData) fetchOrder()

    }, [props.keyTab, props.selectedOption, props.fetchData])

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Origen',
            dataIndex: 'origin', // Field that is goint to be rendered
            render: text => <span style={{ textAlign: 'left' }}>{text}</span>,
        },
        {
            title: 'Tienda destino',
            dataIndex: 'store', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Fecha',
            dataIndex: 'date', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Sistema Origen',
            dataIndex: 'source_system', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Proveedor',
            dataIndex: 'provider', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Estado',
            dataIndex: 'status', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            align: 'right',
            title: '',
            dataIndex: 'key', // Field that is goint to be rendered
            render: (id, data) =>
            (
                <span>
                    {
                        <Popover
                            placement="left"
                            content={
                                <div>
                                    <span className={'user-options-items'} onClick={() => props.onView(dataSource[id].id)}>
                                        Ver
                                    </span>
                                </div>
                            }
                            trigger="click"
                        >
                            <Button shape={'circle'} className={'enterprise-settings-button'}>
                                <MoreOutlined />
                            </Button>
                        </Popover>
                    }
                </span>
            ),
        },
    ]

    const fetchOrder = () => {
        setLoading(true)
        inventorySrc
            .getOrders(props.selectedOption)
            .then(orders => {
                setDataTable(setOrders(orders))
                setExistMoreInfo(orders.data.next_page_url !== null)
                setNextPage(orders.data.next_page_url)
                setLoading(false)
            })
            .catch(e => {
                console.log(e)
                message.error('No se ha podido cargar las ordenes.')
                setLoading(false)
            })
    }

    const handlerMoreButton = () => {
        if (existMoreInfo) {
            setExistMoreInfo(false)
            setLoading(true)
            inventorySrc.getNextPage(nextPage).then(orders => {
                setDataTable(dataTable.concat(setOrders(orders)))
                setExistMoreInfo(orders.data.next_page_url !== null)
                setNextPage(orders.data.next_page_url)
                setLoading(false)
            })
        }
    }

    const setOrders = orders => {
        if (orders !== 'Too Many Attempts.') {
            let _orders = orders.data.data || []
            setDataSource(_orders)

            return _orders.map((d, i) => ({
                key: i,
                id: d.id,
                origin: d.origin,
                store: d.store.name,
                date: Utils.formatDate(d.entry_date),
                status: d.status.description,
                source_system: d.source_system,
                provider: d.provider.name
            }))
        } else {
            message.error('Se excedió el limite de peticiones, espera y recarga la aplicación')
        }
    }

    return (
        <>
            <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Card className={'card-border-radius'}>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                                <Table
                                    className={'CustomTableClass'}
                                    dataSource={dataTable}
                                    columns={columns}
                                    pagination={false}
                                    loading={loading}
                                    rowKey={(record, index) => index}
                                />
                                <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default OrdersTable